import "./Teamsquad.css";
import { useEffect, useRef, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import kelvin from "../../teamImage/kelvin.jpg";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import logo from "../../../../components/images/logo.png";
import Skeleton from "../../../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const Teamsquad = ({ dark, myteam, teamId, MyBaseUrl }) => {
  const team = myteam || null;

  const slug = team
    ? `${team.name?.toLowerCase().replace(/\s+/g, "-")}-${team.api_id || team.id}`
    : "";

  const [squad, setSquad] = useState([]);
  const [loadplayer, setLoadplayer] = useState(false);

  useEffect(() => {
    if (!team) return;

    const fetchSquad = async () => {
      try {
        setLoadplayer(false);

        const response = await fetch(`${MyBaseUrl}/teams/${teamId}/squad`);
        const data = await response.json();

        if (data?.status === "success") {
          const squad = data?.data?.[0]?.players || [];
          setSquad(Array.isArray(squad) ? squad : []);
        } else {
          setSquad([]);
        }

        setLoadplayer(true);
      } catch (error) {
        console.error("Error fetching squad:", error);
      }
    };

    fetchSquad();
  }, [team]);

  const positions = {
    Goalkeepers: [],
    Defenders: [],
    Midfielders: [],
    Forwards: [],
    Others: [],
  };

  squad.forEach((player) => {
    switch (player.position) {
      case "Goalkeeper":
        positions.Goalkeepers.push(player);
        break;
      case "Defender":
        positions.Defenders.push(player);
        break;
      case "Midfielder":
        positions.Midfielders.push(player);
        break;
      case "Attacker":
        positions.Forwards.push(player);
        break;
      default:
        positions.Others.push(player);
    }
  });

  const renderPlayerSection = (title, players) => (
    <section
      className="firstsection"
      style={dark ? { backgroundColor: "#333333ff", boxShadow: "none" } : {}}>
      {Array.isArray(players) && players.length > 0 ? (
        <div className="squadhead" id="squadhead">
          <nav>
            <h2>{title}</h2>
          </nav>
          <span>
            <h2>MP</h2>
            <h2>Goal</h2>
            <h2>Assist</h2>
            <h2>Card</h2>
          </span>
        </div>
      ) : (
        <p></p>
      )}

      {players.map((player) => (
        <NavLink
          to={`/players/${player.name
            ?.trim()
            .replace(/[^a-zA-Z.\s]/g, "")
            .replace(/\s+/g, "-")
            .toLowerCase()}-${player.id}`}
          // to={`/players/${player.name.replace(/\s+/g, "-")}-${player.id}`}
          state={{ player }} // ✅ THIS IS THE MAGIC
          //  to={`/teams/players/${player.id}`}
          key={player.id}>
          <div
            style={
              dark ? { backgroundColor: "#333333ff", boxShadow: "none" } : {}
            }>
            <nav>
              <strong style={dark ? { color: "#fafafaff" } : {}}>
                {player.number || "-"}
              </strong>
              <img
                loading="lazy"
                src={player.photo || kelvin}
                alt={player.name}
              />
              <p style={dark ? { color: "#fafafaff" } : {}}>{player.name}</p>
              <div className="loader"></div>
            </nav>
            <span>
              <h2 style={dark ? { color: "#fafafaff" } : {}}>
                {player.mp || 0}
              </h2>
              <h2 style={dark ? { color: "#fafafaff" } : {}}>
                {player.goal || 0}
              </h2>
              <h2 style={dark ? { color: "#fafafaff" } : {}}>
                {player.assist || 0}
              </h2>
              <h2 style={dark ? { color: "#fafafaff" } : {}}>
                {player.card || 0}
              </h2>
            </span>
          </div>
        </NavLink>
      ))}
    </section>
  );

  const squadRef = useRef(null);

  useEffect(() => {
    if (squadRef.current) {
      squadRef.current.scrollIntoView({
        behavior: "auto",
        inline: "center",
        block: "nearest",
      });
    }
  }, []);

  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {team?.name
            ? `${team.name} Squad | Players & Team Roster | Goal Arena`
            : "Team Squad | Goal Arena"}
        </title>

        <meta
          name="description"
          content={
            team?.name
              ? `View ${team.name} full squad including goalkeepers, defenders, midfielders and forwards. Explore player profiles, stats and squad details on Goal Arena.`
              : "Explore football team squads, player rosters, positions and detailed team lineups on Goal Arena."
          }
        />

        <meta
          name="keywords"
          content={`${team?.name || "football team"} squad, team roster, players list, football lineup, goalkeepers defenders midfielders forwards, Goal Arena`}
        />

        <meta
          property="og:title"
          content={`${team?.name || "Team"} Squad & Players | Goal Arena`}
        />

        <meta
          property="og:description"
          content={`Check out the full ${
            team?.name || "team"
          } squad, including all player positions and roster details.`}
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content={`https://yourdomain.com/teams/${slug}/squad`}
        />
        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={`${team?.name || "Team"} Squad | Goal Arena`}
        />

        <meta
          name="twitter:description"
          content={`Explore full squad list, positions and players for ${
            team?.name || "this team"
          }.`}
        />

        <meta name="twitter:image" content={team?.logo || ""} />

        <link
          rel="canonical"
          href={`https://yourdomain.com/teams/${slug}/squad`}
        />
      </Helmet>

      <div className="homer">
        <div className="teamsquadWrapper">
          {/* <NavLink
            to="/teams"
            style={{ textDecoration: "none" }}
            className="ppp">
            <strong
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: dark ? "none" : "none",
                color: dark ? "white" : "black",
                padding: "5px 10px",
                borderRadius: "5px",
              }}>
              {dark ? (
                <img
                  src={whiteArrow}
                  alt=""
                  className="whitearrow"
                  style={{
                    transform: "rotate(180deg)",
                    scale: "0.7",
                  }}
                />
              ) : (
                <img src={backArrow} alt="" className="blackarrow" />
              )}
            </strong>
          </NavLink>

          <section
            className="section1"
            style={
              dark
                ? { backgroundColor: "#272727ff" }
                : { backgroundColor: "whitesmoke" }
            }>
            <div>
              <img loading="lazy" src={team?.logo} alt={team?.name} />
              <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {team?.name}
              </h1>
            </div>

            <span>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Country: {team?.country}
              </strong>
              <strong style={dark ? { color: "#e2e1e1ff" } : {}}>
                Stadium: {team?.venue_name}
              </strong>
            </span>

            <nav
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      transform: isStickyTop
                        ? "translateX(-0%)"
                        : "translateX(0)",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <ul style={{ backgroundColor: "transparent" }}>
                <NavLink
                  to={`/teams/${slug}`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={
                      dark
                        ? { color: "#fafafaff", backgroundColor: "transparent" }
                        : { backgroundColor: "transparent" }
                    }
                    className="navlink">
                    Overview
                  </li>
                </NavLink>
                <NavLink
                  to={`/teams/${slug}/news`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    News
                  </li>
                </NavLink>
                <NavLink
                  to={`/teams/${slug}/standings`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Standings
                  </li>
                </NavLink>
                <NavLink
                  to={`/teams/${slug}/matches`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="navlink">
                    Matches
                  </li>
                </NavLink>
                <NavLink
                  to={`/teams/${slug}/squad`}
                  style={{ textDecoration: "none" }}>
                  <li
                    style={dark ? { color: "#fafafaff" } : {}}
                    className="myactive"
                    ref={squadRef}>
                    Squad
                  </li>
                </NavLink>
              </ul>
            </nav>
          </section> */}

          {!loadplayer ? (
            <p style={{ marginTop: "-80px", minWidth: "100%" }}>
              <Skeleton dark={dark} count={6} />
            </p>
          ) : (
            <section style={{ width: "100%" }} className="squadsec">
              {renderPlayerSection("Goalkeepers", positions.Goalkeepers)}
              {renderPlayerSection("Defenders", positions.Defenders)}
              {renderPlayerSection("Midfielders", positions.Midfielders)}
              {renderPlayerSection("Forwards", positions.Forwards)}
              {positions.Others.length > 0 &&
                renderPlayerSection("Others", positions.Others)}
            </section>
          )}
        </div>
      </div>
    </>
  );
};

export default Teamsquad;
